import { AnyAction } from 'redux';
import { DriverFuelAssignment } from '../../types';

import { driversActions } from '../reducer';

export const setSelectedDriverFuelAssignment = (
  driverFuelAssignment?: DriverFuelAssignment
): AnyAction => driversActions.setSelectedDriverFuelAssignment(driverFuelAssignment);
